// How a program fee reads on screen, for either shape.

/**
 * The Program Fee cell. It printed `${programFee}%` unconditionally, so a flat client — who carries
 * a stale or absent programFee — showed "40%" or "undefined%" for a fee that is a fixed amount.
 */
export const programFeeLabel = (row) => {
  if (row?.feeType === 'flat') {
    const amount = Number(row?.flatFee) || 0
    return `$${amount.toLocaleString('en-US')}`
  }

  const percent = Number(row?.programFee)
  return Number.isFinite(percent) ? `${percent}%` : '—'
}

/**
 * What the client saves: their enrolled debt less what the program costs them.
 *
 * A zero-balance client has no debt to settle, so the subtraction went negative and the screen
 * offered "-$5,000 of savings". There is no saving there, and there is no negative saving either.
 */
export const resolveSavings = ({ enrolledDebt, programCost } = {}) =>
  Math.max((Number(enrolledDebt) || 0) - (Number(programCost) || 0), 0)
